import React from 'react';
import { LoadingState } from './AdherentMapTypes';

interface LoadingBarProps {
  loadingState: LoadingState;
}

export const AdherentMapLoadingBar: React.FC<LoadingBarProps> = ({ loadingState }) => {
  const { total, completed, failed, isComplete, error } = loadingState;
  
  if (total === 0) return null;
  
  const percentage = Math.round((completed / total) * 100);
  
  return (
    <div className="w-full bg-white rounded-lg shadow-md p-4 mb-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-700">
          Géocodage des adresses des adhérents en cours...
        </span>
        <span className="text-sm font-medium text-gray-700">
          {percentage}%
        </span>
      </div>
      
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className="bg-primary-600 h-2.5 rounded-full transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      <div className="mt-2 text-sm text-gray-500">
        {completed} adresses géocodées sur {total}
        {failed > 0 && ` (${failed} échecs)`}
      </div>
      
      {error && (
        <div className="mt-2 text-sm text-red-600">
          {error}
        </div>
      )}
      
      {isComplete && (
        <div className="mt-2 text-sm text-green-600">
          Géocodage terminé
        </div>
      )}
    </div>
  );
}; 